import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import { reExportedColors } from '../../index'

const CloseIconButton = ({ onClick, className }) => (
  <IconButton
    aria-label='close'
    className={className}
    color='inherit'
    onClick={onClick}
    size='small'
    sx={{
      background: reExportedColors.LIGHT_GREY,
      border: `1px solid ${reExportedColors.LIGHT_GREY}`,
      borderRadius: 1,
      height: 22,
      width: 22,
      '&:hover': {
        background: reExportedColors.LIGHT_GREY,
        border: `1px solid ${reExportedColors.DARK_GREY}`,
        transition: 'border .25s'
      }
    }}
  >
    <CloseIcon fontSize='small' sx={{ color: reExportedColors.DARK_GREY }} />
  </IconButton>
)

export default CloseIconButton
